import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "../../Styles/Itinerary.module.scss";
import pictureOne from "./../../img/Scotland/Itinerary_1.jpeg";
import pictureTwo from "./../../img/Scotland/Itinerary_2.jpeg";
import pictureThree from "./../../img/Scotland/Itinerary_3.jpeg";

function ItalyItinerary() {
  const tripExample = [
    {
      day: "Day 1",
      text: "Depart the USA"
    },
    {
      day: "Day 2",
      text: "Arrive in Edinburgh. If people arrive early on this day, we will plan to do something in Edinburgh with the rest of the day."
    },
    {
      day: "Day 3",
      text: "Tour Edinburgh: After a Castle of Edinburgh tour, we will explore the Royal Mile with a stop at St Giles Cathedral where John Knox led the reformation. This famous street is full of shops, pubs, and interesting sites. We will walk up Calton Hill, a monumental hill with city views. Time and energy permitting, there may be other sites visited."
    },
    {
      day: "Day 4",
      text: "Today we will make the beautiful drive to Newtonmore in the central Scottish Highlands. On the way, we will stop at Stirling and visit the National William Wallace Monument among other possible stops."
    },
    {
      day: "Day 5",
      text: "On this day, we will drive into the Cairngorms National Park and experience the beauty of the Scottish Highlands. We will ride up Cairngorm Mountain on the Mountain Railway, do some hiking and enjoy some great views."
    },
    {
      day: "Day 6",
      text: "In the morning, we will drive to Inverness where we will have lunch. In the afternoon we will drive along the entire west side of Loch Ness (think Loch Ness monster) on our way to Fort Augusta. We will plan to stop at the famous Urquhart Castle, a picturesque ruin on a rocky promontory offering panoramic views, a rich history of clan battles, and association with the Loch Ness Monster, making it one of Scotland's most visited sites for its dramatic scenery and historical significance."
    },
    {
      day: "Day 7",
      text: "On this day, we will explore the most beautiful of all islands of Scotland—Skye. We will visit multiple sites and hopefully do a little hiking at one or more of them, weather permitting."
    },
    {
      day: "Day 8",
      text: "Drive to Oban with stops at Fort William and Glencoe. It is possible to do some driving in the mountains and even hiking near Glencoe. In the evening, we will explore Oban."
    },
    {
      day: "Day 9",
      text: "Day tour to the island of Iona where Columba arrived from Ireland in AD 563, accompanied by twelve companions, to establish a monastery that became a pivotal center for Celtic Christianity, spreading faith to the Scots and Picts. We will ride two ferries and travel through the island of Mull to get to Iona. Mull is also considered to be one of the most beautiful of the Scottish islands."
    },
    {
      day: "Day 10",
      text: "Drive to Edinburgh airport. Fly home"
    }
  ];
  const tripMay = [
    {
      day: "Day 1 - Wednesday, May 20 ",
      text: "Depart the USA"
    },
    {
      day: "Day 2 - Thursday, May 21",
      text: "Arrive in Edinburgh. If people arrive early on this day, we will plan to do something in Edinburgh with the rest of the day."
    },
    {
      day: "Day 3 - Friday, May 22",
      text: "Tour Edinburgh: After a Castle of Edinburgh tour, we will explore the Royal Mile with a stop at St Giles Cathedral where John Knox led the reformation. This famous street is full of shops, pubs, and interesting sites. We will walk up Calton Hill, a monumental hill with city views. Time and energy permitting, there may be other sites visited."
    },
    {
      day: "Day 4 - Saturday, May 23",
      text: "Today we will make the beautiful drive to Newtonmore in the central Scottish Highlands. On the way, we will stop at Stirling and visit the National William Wallace Monument among other possible stops."
    },
    {
      day: "Day 5 - Sunday, May 24",
      text: "On this day, we will drive into the Cairngorms National Park and experience the beauty of the Scottish Highlands. We will ride up Cairngorm Mountain on the Mountain Railway, do some hiking and enjoy some great views."
    },
    {
      day: "Day 6 - Monday, May 25",
      text: "In the morning, we will drive to Inverness where we will have lunch. In the afternoon we will drive along the entire west side of Loch Ness (think Loch Ness monster) on our way to Fort Augusta. We will plan to stop at the famous Urquhart Castle, a picturesque ruin on a rocky promontory offering panoramic views, a rich history of clan battles, and association with the Loch Ness Monster, making it one of Scotland's most visited sites for its dramatic scenery and historical significance."
    },
    {
      day: "Day 7 - Tuesday, May 26",
      text: "On this day, we will explore the most beautiful of all islands of Scotland—Skye. We will visit multiple sites and hopefully do a little hiking at one or more of them, weather permitting."
    },
    {
      day: "Day 8 - Wednesday, May 27",
      text: "Drive to Oban with stops at Fort William and Glencoe. It is possible to do some driving in the mountains and even hiking near Glencoe. In the evening, we will explore Oban."
    },
    {
      day: "Day 9 - Thursday, May 28",
      text: "Day tour to the island of Iona where Columba arrived from Ireland in AD 563, accompanied by twelve companions, to establish a monastery that became a pivotal center for Celtic Christianity, spreading faith to the Scots and Picts. We will ride two ferries and travel through the island of Mull to get to Iona. Mull is also considered to be one of the most beautiful of the Scottish islands."
    },
    {
      day: "Day 10 - Friday, May 29",
      text: "Drive to Edinburgh airport. Fly home"
    }
  ];

  const params = useParams();

  let dates = "";
  let trip = [];

  switch (params.trip) {
    case "May_20-29":
      dates = "May 20 - 29, 2026";
      trip = tripMay;
      break;

    case "trip":
      dates = "";
      trip = tripExample;
      break;
  }

  return (
    <div className="pageContainer">
      <p className="title">Itinerary</p>
      <p className="secondaryTitle">{dates}</p>

      {/* <p className="text">
        This 10-day trip to Switzerland will take you to Zurich, Lucerne,
        Schangnau, Lauterbrunnen, Murren, and Appenzell. Ride to the top of Mt.
        Pilatus and boat on Lake Lucerne. Gondolas, cogwheel trains, and cable
        cars will take you to vistas with mind-blowing views in the heart of the
        Swiss Alps. Learn about the Swiss Reformation, eat traditional Swiss
        food, and enjoy the fellowship of a small tour group.{" "}
      </p> */}
      <div className="pictureRow">
        <div>
          <img className="picture" src={pictureOne} alt="Poland town" />
        </div>
        <div className="hide">
          <img className="picture" src={pictureTwo} alt="Poland solt mines" />
        </div>
        <div>
          <img className="picture" src={pictureThree} alt="Polamd mountains" />
        </div>
      </div>

      {trip.map((item) => (
        <div>
          <h2 className={styles.dayNumber}>{item.day}</h2>
          <p className="text">{item.text}</p>
        </div>
      ))}
    </div>
  );
}

export default ItalyItinerary;
